module.exports = __webpack_public_path__ + "img/plan-red.22d97113.svg";